module.exports = __webpack_public_path__ + "img/adulto27.8d7bc9e7.jpg";